'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'area', 'AreaService', 'StatusService',
    function ($scope, $modalInstance, area, AreaService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.area = angular.copy(area);

            if (area == null || angular.equals({}, area) || area.id == null) {
                $scope.title = "Создание новой площадки";
            } else {
                $scope.title = 'Редактирование площадки "' + $scope.area.name + '"';
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.area.status) {
                    $scope.area.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.area);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                AreaService.api.isUniqueName({name: name, id: $scope.area.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else $scope.uniqueLogin = true;
        }

        // endregion

    }];